import {BitrixVue} from 'ui.vue3';
import { mapState } from 'ui.vue3.pinia';
import { vplSiteStore } from 'vpl.tas';
import { ItemEditBtns } from 'vpl.tas';
import { holdCatalogPreloader, releaseCatalogPreloader } from 'vpl.tas';


export const AkciiPage = {
    components: {
        ItemEditBtns
    },
    props: {
        structKey: [String, Number]
    },
    methods: {
        lazyLoad(link ,append = true){

            link = link.split('#')[0];
            let arRoute = link.split('?');
            let params = 'get_json=Y';
            if(arRoute[1]){
                params += '&' + arRoute[1];
            }

            holdCatalogPreloader();
            $.ajax({
                url: arRoute[0] + '?' + params,
                method: 'GET',
                complete: () => releaseCatalogPreloader(),
                success: (response) => {
                    response = JSON.parse(response);
                    if(append){
                        this.struct[this.structKey].componentData.ITEMS = [...this.items, ...response.struct[this.structKey].componentData.ITEMS];
                    }else{
                        this.struct[this.structKey].componentData.ITEMS = response.struct[this.structKey].componentData.ITEMS;

                        $([document.documentElement, document.body]).animate({
                            scrollTop: $(this.$el).offset().top - 70
                        }, 500);
                    }
                    this.struct[this.structKey].componentData.PAGIN = response.struct[this.structKey].componentData.PAGIN;

                }
            });
        }
    },
    updated(){
        this.items = this.struct[this.structKey].componentData.ITEMS;
        this.pagin = this.struct[this.structKey].componentData.PAGIN;
    },
    mounted(){
        this.items = this.struct[this.structKey].componentData.ITEMS;
        this.pagin = this.struct[this.structKey].componentData.PAGIN;
    },
    computed: {
        ...mapState(vplSiteStore, ['struct', 'SITE_TEMPLATE_PATH'])
    },
    template: `
<section class="section section--first">
    <div class="container">
        <div class="promo__list">

            <div v-for="item in this.struct[this.structKey].componentData.ITEMS" class="promo__item">
                <a :href="item.LINK" class="promo__item-img" :class="{'no-photo': item.PICTURE === false}">
                    <img v-if="item.PICTURE !== false" class="lazy" loading="lazy" src="data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='1' height='1'/%3E" :data-src="item.PICTURE" :alt="item.NAME" :title="item.NAME">
                    <img v-else :src="this.SITE_TEMPLATE_PATH + '/img/svg/no-photo.svg'" :alt="item.NAME" :title="item.NAME" loading="lazy">
                </a>
                <div class="promo__item-info">
                    <div class="promo__item-info-top">
                        <div v-if="item.DATE !== false" class="promo__item-info-leftside">
                            <span>действует до:</span>
                            <div class="promo__item-info-date">
                                <span>{{item.DATE.day}}</span>
                                {{item.DATE.month}}
                            </div>
                        </div>
                        <div v-if="item.DATE !== false" class="promo__item-info-year">‘{{item.DATE.year}}</div>
                    </div>
                    <a :href="item.LINK" class="promo__item-desc">
                        {{item.NAME}}
                    </a>
                </div>
            </div>

            <div class="content-nav" v-if="this.struct[this.structKey].componentData.PAGIN">
                <ul class="content-nav__list">
                    <template v-for="link in this.struct[this.structKey].componentData.PAGIN">
                        <li v-if="link.type==='left_arrow'" class="content-nav__list-item content-nav__list-item--prev">
                            <a :href="link.link" @click.prevent="lazyLoad(link.link, false)" data-skip="y">
                                <svg class="icon icon-arrow-prev"><use xlink:href="#icon-arrow-prev"></use></svg>
                            </a>
                        </li>
                        <li v-if="link.type==='number'" :class="{active: link.selected}" class="content-nav__list-item"><a @click.prevent="lazyLoad(link.link, false)" data-skip="y" :href="link.selected ? '#' : link.link">{{ link.text }}</a></li>
                        <li v-if="link.type==='dots'" class="content-nav__list-item"><a @click.prevent="lazyLoad(link.link, false)" data-skip="y" :href="link.link">...</a></li>
                        <li v-if="link.type==='right_arrow'" class="content-nav__list-item content-nav__list-item--next">
                            <a :href="link.link" data-skip="y" @click.prevent="lazyLoad(link.link, false)">
                                <svg class="icon icon-arrow-next"><use xlink:href="#icon-arrow-next"></use></svg>
                            </a>
                        </li>
                    </template>
                </ul>

                <template v-for="link in this.struct[this.structKey].componentData.PAGIN">
                    <a v-if="link.type==='showmore'" href="#" @click.prevent="lazyLoad(link.link)" class="btn btn--border">Показать ещё</a>
                </template>
            </div>
        </div>
    </div>
</section>
    `
}
